import {Directive, EventEmitter, Input, NgModule, Output} from '@angular/core';

export type SortDirection = 'asc' | 'desc' | '';

export interface Sort {
  active: string;
  direction: SortDirection;
}

@Directive({
  selector: '[sdSort]',
  standalone: true,
  exportAs: 'sdSort',
  host: {class: 'sd-sort'},
})
export class SdSort {
  active = '';
  direction: SortDirection = '';
  @Input() sdSortActive = '';
  @Input() sdSortDirection: SortDirection = '';
  @Input() sdSortDisableClear = false;
  @Output() sdSortChange = new EventEmitter<Sort>();

  sort(id: string): void {
    if (this.active !== id) {
      this.active = id;
      this.direction = 'asc';
    } else if (this.direction === 'asc') {
      this.direction = 'desc';
    } else {
      this.active = this.sdSortDisableClear ? id : '';
      this.direction = this.sdSortDisableClear ? 'asc' : '';
    }
    this.sdSortChange.emit({active: this.active, direction: this.direction});
  }
}

@Directive({
  selector: '[sd-sort-header], [sdSortHeader]',
  standalone: true,
  host: {
    class: 'sd-sort-header cursor-pointer select-none',
    '(click)': 'onClick()',
  },
})
export class SdSortHeader {
  @Input('sd-sort-header') id = '';
  @Input() sdSortHeader = '';
  @Input() disabled = false;

  constructor(private readonly sort: SdSort) {}

  onClick(): void {
    if (this.disabled) {
      return;
    }
    this.sort.sort(this.id || this.sdSortHeader);
  }
}

@NgModule({
  imports: [SdSort, SdSortHeader],
  exports: [SdSort, SdSortHeader],
})
export class SdSortModule {}
